<template>
	<b-container id="MasterPage" fluid class="d-flex flex-column p-0">
		<b-row id="MasterRow1" class="p-0 w-100 no-gutters">
			 <Header :WorkingMode="workingMode" :NewsNotifications="newsNotifications"/> 
		</b-row>
		<b-row id="MasterRow2" class="p-0 flex-grow-1 overflow-auto w-100 no-gutters">
			<b-overlay no-center :show="displayOverlay" class="d-flex flex-column h-100 w-100">
				<!-- Tableau de bord principal -->
				<MainDashboards v-if="masterAction('MainDashboard')" v-show="workingMode===workingModeEnum.MainDashboard" :Action="masterAction('MainDashboard')" @NoMainDashboardsEvent="goWorkbench()" />

				<!-- Carte principale -->
				<MainMap v-if="masterAction('Map')" v-show="workingMode===workingModeEnum.Map && isMapVisible" />

				<!-- v-if utilisé pour empêcher le rendu dans le DOM s'il s'agit d'un mobile. -->
				<!-- v-show permet de garder le rendu mais de le masquer selon le workingmode  -->
				<Workbench v-if="masterAction('Workbench')" v-show="workingMode===workingModeEnum.Workbench" :Action="masterAction('Workbench')" />

				<!-- Affichage de la page d'administration-->
				<!-- TODO : ne permettre l'accès à cette partie que pour les admins !!!!! ==> A VOIR AVEC SLAVINA !!! -->
				<Administration v-if="workingMode===workingModeEnum.Administration" />

				<!-- Affichage IFrame pour le Système d'alertes -->
				<IFrameLoader v-if="masterAction('Alert') && workingMode===workingModeEnum.Alert" Link="Alert/Alert_Page.aspx?appvers=v3" />

				<!-- Overlay quand aucun tableau de bord n'existe -->
				<template #overlay>
					<Welcome Variant="primary" class="flex-grow-1">
						<!-- Suppression message de bienvenue par défaut-->
						<template v-slot:WelcomeMessage>
							{{ $t('Welcome') }}  <!-- Bienvenue sur le portail -->
						</template>
					</Welcome>
				</template>
			</b-overlay>
		</b-row>
		<!-- Apparition des news-->
		<!-- :Visible :  Lie l'état de visibilité depuis le parent -->
		<!-- @update:Visible : Écoute les changements de visibilité depuis le composant enfant -->
		<News v-if="isEndOfLoadingState && (newsNotificationsAtTheBegining.length > 0 || newsNotifications.length > 0)"
			:Visible="isNewsVisible" 
			@update:Visible="toggleNewsModal"
			:NewsNotifications="newsNotificationsAtTheBegining"
		/>

		<!-- Apparition du formulaire de satisfaction -->
		<SatisfactionSurvey v-if="isEndOfLoadingState" /> 
	</b-container>
</template>

<script lang="ts">
	import { Component} from 'vue-property-decorator';
	import { Getter} from 'vuex-class';
	import { API_URL, MAIN_FILTER_TREE } from '@/App.settings';
	import moment from 'moment';
	import Header from './MasterPage/Header.vue';
	import Welcome from '@/components/commons/Welcome.vue';
	import MainMap from './MasterPage/MainMap.vue';
	import MainDashboards from './MasterPage/MainDashboards.vue';
	import Workbench from './MasterPage/Workbench.vue';
	import Administration from './MasterPage/Administration.vue';
	import WorkingModeEnum from '@/enums/WorkingModeEnum';
	import IFrameLoader from "@/components/commons/IFrameLoader.vue";
	import { ObjectUtils } from "@/components/commons/Utils";
	import locales from "./locales/MasterPage.json";
	import filterTreeLocales from "@/store/locales/FilterTree.json";
	import News from '@/components/commons/News.vue';
	import NewsNotification from '@/types/NewsNotification';
	import SatisfactionSurvey from '@/components/commons/SatisfactionSurvey.vue';
	import Dictionary from '@/types/Dictionary';
	import axios from 'axios';
	import SelectModeEnum from '@/enums/SelectModeEnum';

	/** Page principale */
	@Component({
		components: {
			Header,
			Welcome,
			MainMap,
			MainDashboards,
			Workbench,
			Administration,
			IFrameLoader,
			News,
    		SatisfactionSurvey
		},
		i18n: { messages: locales }
	})
	export default class MasterPage extends ObjectUtils {
		/** Pour pouvoir utiliser l'enum WorkingModeEnum dans la section template */
		private workingModeEnum = WorkingModeEnum;

		@Getter('CartoMod/GetIsVisible')
		private isMapVisible!: boolean;

		/** Mode de travail (tableau de bord principal par défaut) */
		@Getter('GetWorkingMode')
		private workingMode!: WorkingModeEnum;

		private displayOverlay: boolean = false;

		/** Obtient les droits associés à une fonction */
		@Getter('GetMasterAction')
        private masterAction!: (featureName: string) => string | undefined;

		/** Getter pour la liste des notifications à l'ouverture de la session */
		@Getter('NotificationsStore/GetNewsAtBeginningNotifications')
		private newsNotificationsAtTheBegining!: NewsNotification[];

		/** Getter pour la liste des notifications au click du bouton notification dans le header */
		@Getter('NotificationsStore/GetNewsNotifications')
		private newsNotifications!: NewsNotification[];

		/** Getter pour l'état de visibilité de la modale */
		@Getter('NotificationsStore/GetIsNewsVisible')
		private isNewsVisible!: boolean;

		/** Méthode pour basculer la visibilité de la modal News */
		toggleNewsModal(isVisible: boolean): void {
			if (isVisible) {
				this.$store.dispatch('NotificationsStore/DisplayNews');
			} else {
				this.$store.dispatch('NotificationsStore/HideNews');
			}
		}

		/** Bascule sur l'espace de travail */
		private goWorkbench() {
			/** Bascule sur l'espace de travail uniquement si l'utilisateur a les droits d'accéder à l'espace de travail */
			this.$store.dispatch('ToggleMode', WorkingModeEnum.Workbench).catch(err => { console.error(err) });
		}

		/** Indique si le formulaire de satisfaction peut s'afficher ou non en fonction de l'etat du chargeme,t
		 * @todo A voir si suffit ou bien de mettre ça lorsque sur retour d'une promise sur tout ce qui est chargé dans ce created
		 */
		private isEndOfLoadingState: boolean = false;

		/** Pour désactiver le watcher sur le changement de langue */
		private unwatchGetLanguage = undefined;

		async created() {

			if( this.$cookies.get('access_token') ) {
				/** 
				 * Test si l'utilisateur doit choisir une base clients.
				 * Protège contre les accès sans base sélectionné.
				 */
				const args: Dictionary<any> = {};
				args["Token"] = this.$cookies.get('access_token') != null ? <string>this.$cookies.get('access_token') : "";
				const response = await axios.post(API_URL + "Connexion/IsBaseSelected", args);
				if (response && response.data && !response.data.isBaseSelected){ /** Si oui, retour sur la page de connexion pour choisir une base */
					await this.$router.push({ name: 'Connexion' }); 
					return;
				} 
			}
			else {
				console.warn("MasterPage.vue - Pas d'access_token !!!");
				console.trace();
			}
				
			/** Gestion des droits utilisateurs */
			this.$store.dispatch("LoadFeaturesMaster").then(() => {
				// Gestion des droits utilisateurs
				this.displayOverlay = true;

				if (this.masterAction('MainDashboard') && this.masterAction('Workbench')) 
					this.displayOverlay = false;
				else if (!this.masterAction('MainDashboard')) {
					// Si pas d'accès au tableau de bord principal alors on bascule sur l'espace de travail
					this.$store.dispatch('ToggleMode', WorkingModeEnum.Workbench).then(() => { this.displayOverlay = false; });
				}
				else if (!this.masterAction('Workbench')) {
					// Si pas d'accès  alors on bascule sur le tableau de bord principal
					this.$store.dispatch('ToggleMode', WorkingModeEnum.MainDashboard).then(() => { this.displayOverlay = false; });
				}
			})
			.catch(err => {
				console.error(err);
				this.$bvToast.toast(this.$t('ErrorLoadingMasterFunctions').toString(), { // "Une erreur s'est produite sur le chargement des fonctions Master."
					title: this.$t('Error').toString(),
					autoHideDelay: 10000,
					variant: "danger",
					solid: true,
					appendToast: true,
					toaster: "b-toaster-top-center"
				});
			});

			// if (!($screen.breakpoint === 'xs' || $screen.breakpoint === 'sm')) {
				/** Chargement des données nécessaires au démarrage */

				/** Initialisation de l'icone, nom de la base de données */
				await this.$store.dispatch("SessionStore/Load").then(() => {
					console.info("MasterPage - Initialisation de l'icone, nom de la base de données et langue terminée. lang : ", this.$store.getters['SessionStore/GetLanguage']);
				})
				.catch(async err => {
					console.error(err);
					this.$bvToast.toast(this.$t('ErrorLoadingSessionStore').toString(), {	// "Une erreur s'est produite lors du chargement des informations de session."
						title: this.$t('Error').toString(),
						autoHideDelay: 10000,
						variant: "danger",
						solid: true,
						appendToast: true,
						toaster: "b-toaster-top-center"
					});
				});

				/** Watcher détectant le changement de langue pour l'appliquer dans toute l'application */
				this.unwatchGetLanguage = this.$store.watch((state, getters) => getters['SessionStore/GetLanguage'], (newVal, oldVal) => {
					/** Change la langue de l'instance globale de VueI18n */
					this.$root.$i18n.locale = newVal;
					/** Chargement des traductions de l'arborescence */
					this.$root.$i18n.mergeLocaleMessage(this.$root.$i18n.locale, filterTreeLocales[this.$root.$i18n.locale]);
					/** Change la culture/langue utilisée par moment */
					moment.locale(newVal?.toLocaleLowerCase());
					console.info("MasterPage - Changement de langue de '%s' vers '%s' - this.$root.$i18n.locale : %s", oldVal, newVal, this.$root.$i18n.locale);
				}, { immediate: true });

/** Chargement de l'arborescence d'objets uniquement si on a accès à l'espace de travail */
				// if (this.masterAction('Workbench')) {
					await this.$store.dispatch(MAIN_FILTER_TREE + "/LoadData", { selectMode : SelectModeEnum.Single }).then(() => {
						/** Applique la fonction par défaut */
						this.$store.dispatch('SetDefaultFeature', {});

						console.info("Master - Chargement de l'arborescence terminé !");

						/** @todo A voir si suffit ou bien de mettre ça lorsque sur retour d'une promise sur tout ce qui est chargé dans ce created */
				
						this.isEndOfLoadingState = true;
						console.info("Master - Chargement de l'arborescence terminée !");	

					})
					.catch(err => {
						console.error(err);
						this.$bvToast.toast(this.$t('ErrorLoadingTree').toString(), { //  "Une erreur s'est produite sur le chargement de l'arborescence d'objets"
							title: this.$t('Error').toString(),
							autoHideDelay: 10000,
							variant: "danger",
							solid: true,
							appendToast: true,
							toaster: "b-toaster-top-center"
						});
					});
				// }

				/** Requête le serveur pour obtenir la liste des fonctions si elle n'est pas déjà chargée */
				await this.$store.dispatch("LoadFeaturesMenu")
					.then(() => {
						console.info("Master - Chargement de la liste des fonctions terminée !");
					})
					.catch(err => {
						console.error(err);
						this.$bvToast.toast(this.$t('FeatureLoadingError').toString(), {	// "Une erreur s'est produite sur le chargement de la liste des fonctions."
							title: this.$t('Error').toString(),	// "Erreur"
							autoHideDelay: 10000,
							variant: "danger",
							solid: true,
							appendToast: true,
							toaster: "b-toaster-top-center"
						});
					});

				// Initialisation de la map
				await this.$store.dispatch("CartoMod/InitMapSettings").then(response => {
					console.info("Master - Initialisation de la map terminée !");
				})
				.catch(err => {
					console.error(err);
					this.$bvToast.toast(this.$t('ErrorInitMap').toString(), { //"Une erreur s'est produite sur l'initialisation de la map."
						title: this.$t('Error').toString(),
						autoHideDelay: 10000,
						variant: "danger",
						solid: true,
						appendToast: true,
						toaster: "b-toaster-top-center"
					});
				});

				/** Chargement de la bibliothèque de widgets */
				await this.$store.dispatch("WidgetLibraryStore/LoadData").catch(err => {
					console.error(err);
					this.$bvToast.toast(this.$t('ErrorLoadWidgetLibrary').toString(), { // "Une erreur s'est produite sur lors du chargement de la bibliothèque de widget"
						title: this.$t('Error').toString(),
						autoHideDelay: 10000,
						variant: "danger",
						solid: true,
						appendToast: true,
						toaster: "b-toaster-top-center"
					});
				});

				/** Chargement des contraintes pour drag'n'drop */
				await this.$store.dispatch("MenuStore/LoadData").then(() => {
						console.info("Master - Chargement du menu terminé !");
					})
					.catch(err => {
						console.error(err);
						this.$bvToast.toast(this.$t('AnErrorOccured').toString(), {
							title: this.$t('ErrorLoadingConstraints').toString(),
							autoHideDelay: 10000,
							variant: "danger",
							solid: true,
							appendToast: true,
							toaster: "b-toaster-top-center"
						});
					});
			// }

			/** Fonction pour récupérer la liste des news à afficher au début de la session */
            await this.$store.dispatch('NotificationsStore/GetNewsManagerAtBeginning')
				.then(()=> {
					if (this.newsNotificationsAtTheBegining && this.newsNotificationsAtTheBegining.length > 0)
						this.$store.dispatch('NotificationsStore/DisplayNews');
				}) 
				.catch((err) => {
					console.error(err);
					
					this.$bvToast.toast(this.$t('AnErrorOccured').toString(), {
						title: this.$t('Error').toString(),
						autoHideDelay: 10000,
						variant: "danger",
						solid: true,
						appendToast: true,
						toaster: "b-toaster-top-center"
					});

					this.$store.dispatch('NotificationsStore/HideNews');
				});

				/** Récupérer la liste des news au click du bouton notification dans le Header */
				await this.$store.dispatch('NotificationsStore/LoadNewsNotifications', { lazy : true })
					.then(()=> {
						if (this.newsNotifications && this.newsNotifications.length > 0) {
							
						}
					}) 
					.catch((err) => {
						console.error(err);
						this.$bvToast.toast(this.$t('AnErrorOccured').toString(), {
							title: this.$t('Error').toString(),
							autoHideDelay: 10000,
							variant: "danger",
							solid: true,
							appendToast: true,
							toaster: "b-toaster-top-center"
						});
					});

				// Permet de charger les partages (Tableau de bord, Périmètre, Masque), afin d'afficher un badge des partages en attentes dans Header
				await this.$store.dispatch('LoadSharableItems').catch(console.error);
		}

		beforeDestroy() {
			if (this.unwatchGetLanguage)
				this.unwatchGetLanguage();
		}
	}
</script>

<style scoped>
	/** @hack : Pour palier au bug de boostrap avec le v-show qui ne met pas le !important sur le display: none et cause l'affichage de components qui devraient être masqués */
	*[style*="display: none"] {
		display: none !important;
	}

	/** 
	* Utilisation de l'unité dvh pour éviter le rognage du bas de la page sur les écrans de type mobile (uniquement si supporté par le navigateur)
	* @see https://chanind.github.io/javascript/2019/09/28/avoid-100vh-on-mobile-web.html
	* @see https://blog.logrocket.com/improving-mobile-design-latest-css-viewport-units/
	*/
	#MasterPage {
		height: var(--fullHeight);
	}

</style>